<template>
  <div>
    <div class="agit-map-container">
      <div class="agit-map-wrapper">
        <div class="agit-map">
          <img class="agit-map__img" src="/images/homepage/agit-map.png" alt="서울 전역 지도">
          <button v-for="button in buttons"  v-bind:class="`agit-point agit-point--${guMatch[button.addrGu]}`" @click="changeList(button.addrGu)"><label class="agit-point__label">{{button.addrGu}}</label>{{button.guCount}}<p class="alt-text">{{button.addrGu}} {{button.guCount}} 개소</p></button>
        </div>
      </div>
    </div>


    <div class="agit-list-wrapper">
      <p class="agit-list-helper">* 원하시는 자치구를 클릭하시면 해당하는 협력기관을 확인하실 수 있습니다.</p>
      <h4 class="agit-box__text agit-box__text--location" id="titleGu"></h4>
      <ul class="agit-boxs">
        <li class="agit-box clearfix" v-for="agit in agites">
          <div class="agit-box__text agit-box__text--location">{{agit.name}}</div>
          <div class="agit-box__text agit-box__text--gu">{{agit.addrGu}}</div>
          <div class="agit-box__text agit-box__text--address">{{agit.addr1}} {{agit.addr2}}</div>
          <a :href="agit.url" class="agit-box__text agit-box__text--link" target="_blank" rel="noopener noreferrer" title="새창열림">{{agit.url}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  const AgitTypes = {
    FOUNDATION: '재단',
    COMMUNITY: '커뮤니티',
    GROUP: '그룹',
    CENTER: '센터',
    CAMPUS: '캠퍼스',
    PORTAL: '포털',
  };

  const guMatch = {
    강서구: 'gs',
    양천구: 'yc',
    구로구: 'gr',
    영등포구: 'ydp',
    금천구: 'gc',
    동작구: 'dj',
    관악구: 'ga',
    은평구: 'ep',
    서대문구: 'sdm',
    마포구: 'mp',
    종로구: 'jr',
    중구: 'j',
    용산구: 'ys',
    도봉구: 'db',
    강북구: 'gb',
    노원구: 'nw',
    성북구: 'sb',
    동대문구: 'ddm',
    중랑구: 'jn',
    성동구: 'sd',
    광진구: 'gj',
    서초구: 'sc',
    강남구: 'gn',
    송파구: 'sp',
    강동구: 'gd',
  };
  export default {
    name: 'portal-agit',
    props: ['agitList'],
    data() {
      return {
        AgitTypes,
        guMatch,
        agites: this.agitList,
      };
    },
    computed: {
      buttons() {
        const buttonArray = [];
        const guArray = [];
        this.agitList.forEach((agit) => {
          if (guArray.indexOf(guMatch[agit.addrGu]) === -1) {
            buttonArray.push({
              guEn: guMatch[agit.addrGu],
              addr1: agit.addr1,
              addr2: agit.addr2,
              addrGu: agit.addrGu,
              type: agit.type,
              url: agit.url,
              name: agit.name,
              guCount: 1,
            });
            guArray.push(guMatch[agit.addrGu]);
          } else {
            buttonArray[guArray.indexOf(guMatch[agit.addrGu])].guCount += 1;
          }
        });
        return buttonArray;
      },
    },
    methods: {
      changeList(gu) {
        const agitArray = [];
        this.agitList.forEach((agit) => {
          if (agit.addrGu === gu) {
            agitArray.push(agit);
          }
        });
        this.agites = agitArray;
        document.getElementById('titleGu').innerHTML = `${gu} 협력기관 목록`;
      },
    },

  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// PortalAgit.vue?60a84c8b